import React, { useState, useEffect,  useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import s from "../styles/EditVehicle.module.css";
import PhotoEditor from "./Photo_Editor";
import Modal from "react-modal";
import { AuthContext } from '../AuthContext';


const EditVehicle = () => {
  const { role} = useContext(AuthContext); 

  const { id } = useParams();
  const navigate = useNavigate();
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [ConfirmModalOpen, setConfirmModalOpen] = useState(false);

  const [complectModalOpen, setComplectModalOpen] = useState(false); // Модалка комплектаций
  const [complects, setComplects] = useState([]); // Список комплектаций
  const [selectedComplects, setSelectedComplects] = useState([]); // Выбра
    
  // Функция открытия модалки подтверждения
  const openConfirmModal = () => {
    setConfirmModalOpen(true);
  };

  // Функция закрытия модалки
  const closeConfirmModal = () => {
    setConfirmModalOpen(false);
  };


  // 📌 Загрузка данных автомобиля
  useEffect(() => {
    const fetchVehicle = async () => {
      try {
        const response = await fetch(`/api/vehicles_edit/${id}`);
        if (!response.ok) throw new Error("Ошибка загрузки данных");
        const data = await response.json();
        setVehicle(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVehicle();
  }, [id]);


  // 📌 Загрузка списка комплектаций
  useEffect(() => {
    const fetchComplects = async () => {
      try {
        const response = await fetch("/api/vehicle/get_complect");
        if (!response.ok) throw new Error("Ошибка загрузки комплектаций");
        const data = await response.json();
        setComplects(data);
      } catch (err) {
        console.error("Ошибка:", err);
      }
    };

    fetchComplects();
  }, []);

  const handleBack = async () => {
    navigate(`/dashboard`);
  }
  // 📌 Обновление данных автомобиля
  const handleUpdate = async () => {
    try {
      const response = await fetch(`/api/vehicles/update/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(vehicle),
      });

      if (!response.ok) throw new Error("Ошибка обновления");
      navigate(`/vehicles/${id}`);
    } catch (err) {
      setError(err.message);
    }
  };

   // 📌 Открытие модального окна для комплектаций
   const openComplectModal = () => {
    setComplectModalOpen(true);
  };

  // 📌 Закрытие модального окна комплектаций
  const closeComplectModal = () => {
    setComplectModalOpen(false);
  };

  // 📌 Выбор комплектации (добавление или удаление из списка)
  const toggleComplect = (complectName) => {
    setSelectedComplects((prev) =>
      prev.includes(complectName)
        ? prev.filter((c) => c !== complectName)
        : [...prev, complectName]
    );
  };

  // 📌 Применение выбранных комплектаций в поле
  const applyComplects = () => {
    setVehicle((prev) => ({
      ...prev,
      configuration: selectedComplects.join(", "),
    }));
    closeComplectModal();
  };

  if (loading) return <p>Загрузка...</p>;
  if (error) return <p style={{ color: "red" }}>Ошибка: {error}</p>;

  return (
 
    <div className={s.edit_container}>
      
      <h2 className={s.edit_h2}>Редактор авто</h2>
      <div className={s.header_brand_model_date}>
       <p>{vehicle.vin ?? ""}</p>
      <p>{vehicle.date_acceptance  ?? ""}</p> 
      <p>{vehicle.color ?? ""}</p>
      </div>
      
      <div className={s.lable_section_div}>Фото</div>
      <PhotoEditor vehicleId={id} />
      
        
        <div className={s.lable_section_div}>общая информация</div>
        <div className={s.section_div}>
              
              <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Марка</label>
                <input className={s.edit_input} type="text" value={vehicle.brand ?? ""} onChange={(e) => setVehicle({ ...vehicle, brand: e.target.value })} />
              </div>

              <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Модель</label>
                <input className={s.edit_input} type="text" value={vehicle.model ?? ""} onChange={(e) => setVehicle({ ...vehicle, model: e.target.value })} />
                </div>

              <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Тип ТС</label>
                <input className={s.edit_input} type="text" value={vehicle.vehicle_type ?? ""} onChange={(e) => setVehicle({ ...vehicle, vehicle_type: e.target.value })} />
              </div>

              <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>VIN</label>
                <input className={s.edit_input} type="text" value={vehicle.vin ?? ""} onChange={(e) => setVehicle({ ...vehicle, vin: e.target.value })} disabled />
                </div>

                <div className={s.input_edit_wrapper}>
                  <label className={s.edit_label}>Цвет</label>
                  <input className={s.edit_input} type="text" value={vehicle.color ?? ""} onChange={(e) => setVehicle({ ...vehicle, color: e.target.value })} />
                </div>
                
                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Дата приемки</label>
                <input className={s.edit_input} type="date" value={vehicle.date_acceptance  ?? ""} onChange={(e) => setVehicle({ ...vehicle, date_acceptance: e.target.value })} />
                </div>
        </div>

        <div className={s.lable_section_div}>Дополнительная информация</div>
        <div className={s.section_div}>
            <div className={s.input_edit_wrapper}>       
              <label className={s.edit_label}>Пробег</label>
              <input className={s.edit_input} type="text" value={vehicle.mileage ?? ""} onChange={(e) => setVehicle({ ...vehicle, mileage: e.target.value })} />
              </div>

            <div className={s.input_edit_wrapper}>
              <label className={s.edit_label}>Мойка снаружи</label>
              <input className={s.edit_input} type="date" value={vehicle.washing_exterior ?? ""} onChange={(e) => setVehicle({ ...vehicle, washing_exterior: e.target.value })} />
              </div>

            <div className={s.input_edit_wrapper}>
              <label className={s.edit_label}>Мойка кабины</label>
              <input className={s.edit_input} type="date" value={vehicle.washing_cabin ?? ""} onChange={(e) => setVehicle({ ...vehicle, washing_cabin: e.target.value })} />
              </div>

              <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Комплектация</label>
                <div className={s.complectInputContainer}>
                  <input
                    className={s.edit_input}
                    type="text"
                    value={vehicle.configuration ?? ""}
                    readOnly
                  />
                  <button onClick={openComplectModal} className={s.openComplectButton}>
                    Выбрать комплектации
                  </button>
                </div>
              </div>
              
              <div className={s.input_edit_wrapper}>
                <label className={s.edit_label_text_area}>Недостатки по комплектности</label>
              <textarea className={s.edit_textarea} value={vehicle.completeness_defects ?? ""} onChange={(e) => setVehicle({ ...vehicle, completeness_defects: e.target.value })} />
              </div>
              
              <div className={s.input_edit_wrapper}>
              <label className={s.edit_label_text_area}>Дефекты:</label>
              <textarea className={s.edit_textarea} value={vehicle.defects ?? ""} onChange={(e) => setVehicle({ ...vehicle, defects: e.target.value })} />
              </div>
              
                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label_text_area}>Ошибки:</label>
                <textarea className={s.edit_textarea} value={vehicle.errors ?? ""} onChange={(e) => setVehicle({ ...vehicle, errors: e.target.value })} />
                </div>
                
                <div className={s.input_edit_wrapper}>
                  <label className={s.edit_label}>Дата заявки:</label>
                <input className={s.edit_input} type="date" value={vehicle.request_date ?? ""} onChange={(e) => setVehicle({ ...vehicle, request_date: e.target.value })} />
                </div>
                
                <div className={s.input_edit_wrapper}>
                  <label className={s.edit_label}>План работ в сервисе:</label>
                <textarea className={s.edit_textarea} value={vehicle.service_plan ?? ""} onChange={(e) => setVehicle({ ...vehicle, service_plan: e.target.value })} />
                </div>
              
                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label_text_area}>Гарантийные работы:</label>
                <textarea className={s.edit_textarea} value={vehicle.warranty_work ?? ""} onChange={(e) => setVehicle({ ...vehicle, warranty_work: e.target.value })} />
                </div>

                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label_text_area}>Результат работ в сервисе:</label>
                <textarea className={s.edit_textarea} value={vehicle.service_result ?? ""} onChange={(e) => setVehicle({ ...vehicle, service_result: e.target.value })} />
                </div>
                
                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label_text_area}>ТО:</label>
                <textarea className={s.edit_textarea} value={vehicle.maintenance ?? ""} onChange={(e) => setVehicle({ ...vehicle, maintenance: e.target.value })} />
                </div>

                <div className={s.input_edit_wrapper}>
                  <label className={s.edit_label_text_area}>Примечание:</label>
                <textarea className={s.edit_textarea} value={vehicle.note ?? ""} onChange={(e) => setVehicle({ ...vehicle, note: e.target.value })} />
                </div>
                
                <div className={s.input_edit_wrapper}>
                  <label className={s.edit_label_text_area}>Техническое задание:</label>
                <textarea className={s.edit_textarea} value={vehicle.technical_task ?? ""} onChange={(e) => setVehicle({ ...vehicle, technical_task: e.target.value })} />
                </div>
              
                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Установка УВЭОС:</label>
                <input className={s.edit_input} type="date" value={vehicle.uv_installation ?? ""} onChange={(e) => setVehicle({ ...vehicle, uv_installation: e.target.value })} />
                </div>

                <div className={s.input_edit_wrapper}>
                  <label className={s.edit_label}>Отключение мочевины:</label>
                <input className={s.edit_input} type="date" value={vehicle.adblue_disable ?? ""} onChange={(e) => setVehicle({ ...vehicle, adblue_disable: e.target.value })} />
                </div>
                
                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Установка маяка лизинг:</label>
                <input className={s.edit_input} type="date" value={vehicle.leasing_beacon_installation ?? ""} onChange={(e) => setVehicle({ ...vehicle, leasing_beacon_installation: e.target.value })} />
                </div>

                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Дата отгрузки:</label>
                <input className={s.edit_input} type="date" value={vehicle.shipment_date ?? ""} onChange={(e) => setVehicle({ ...vehicle, shipment_date: e.target.value })} />
                </div>

                <div className={s.input_edit_wrapper}>
                <label className={s.edit_label}>Менеджер:</label>
                <input className={s.edit_input} type="text" value={vehicle.manager ?? ""} onChange={(e) => setVehicle({ ...vehicle, manager: e.target.value })} />
                </div>

                {role === "superadmin" || role === "admin" || role === "full" ? (
                  <>
                  <div className={s.input_edit_wrapper}>
                  <label className={s.edit_label}>Статус:</label>
                  <select 
                    className={s.edit_input} 
                    value={vehicle.vehicle_status ?? "В процессе"} 
                    onChange={(e) => setVehicle({ ...vehicle, vehicle_status: e.target.value })}
                  >
                    <option value="В процессе">В процессе</option>
                    <option value="Готов">Готов</option>
                  </select>
                  </div>
                  </>
                ):(
                  <></>
                )}


                {/* Блок для office-manager, если статус "Готов" */}
                {(role === "superadmin" || role === "admin" || role === "office-manager") && vehicle.vehicle_status === "Готов" ? (
                  <>
                  <div className={s.input_edit_wrapper}>
                    <label className={s.edit_label}>Отгружено:</label>
                    <select 
                      className={s.edit_input} 
                      value={vehicle.arhiv ?? "Нет"} 
                      onChange={(e) => setVehicle({ ...vehicle, arhiv: e.target.value })}
                    >
                      <option value="Нет">Нет</option>
                      <option value="ОТГРУЖЕНО">ОТГРУЖЕНО</option>
                    </select>
                  </div>
                  
                  </>
                ) : null}
                <div className={s.finish_div}>
                </div>
        </div>



        <div className={s.footter_Buttons_div}>
        <button onClick={openConfirmModal} className={s.footter_cancel_Button}>Отмена</button>
          <button onClick={openConfirmModal} className={s.footter_save_Button}>Сохранить</button>
        </div>
        
        <Modal
          isOpen={complectModalOpen}
          onRequestClose={closeComplectModal}
          className={s.modalContent}
          overlayClassName={s.modalOverlay}
          appElement={document.getElementById("root")}
        >
          <h2 className={s.modalTitle}>Выберите комплектации</h2>
          <div className={s.modalBody}>
            {complects.map((complect) => (
              <label key={complect.id} className={s.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={selectedComplects.includes(complect.complect_name)}
                  onChange={() => toggleComplect(complect.complect_name)}
                />
                {complect.complect_name}
              </label>
            ))}
          </div>
          <div className={s.buttonGroup}>
            <button onClick={applyComplects} className={s.confirmButton}>
              Применить
            </button>
            <button onClick={closeComplectModal} className={s.cancelButton}>
              Отмена
            </button>
          </div>
        </Modal>

        {/* Модальное окно подтверждения */}
      <Modal
        isOpen={ConfirmModalOpen}
        onRequestClose={closeConfirmModal}
        className={s.modalContentConfirm}
        overlayClassName={s.openphotoConfirm}
        appElement={document.getElementById("root")} // Указываем root
      >
        <div className={s.confirm_modal_header_x}>
          <h2 className={s.modalTitleConfirm}>Сохранить изменения?</h2>
          <button onClick={closeConfirmModal} className={s.cancelButtonConfirm}>
            X
          </button>
        </div>
        
        
        <p className={s.modalTextConfirm}>Вы уверены, что хотите сохранить изменения?</p>
        <div className={s.buttonGroupConfirm}>
          <button onClick={handleBack} className={s.backButtonConfirm}>
            Не сохранять
          </button>
          <button onClick={handleUpdate} className={s.confirmButtonConfirm}>
            Сохранить
          </button>
          
          
        </div>
      </Modal>
    </div>
  
  );
};

export default EditVehicle;
